import React, { useEffect } from 'react';
import { CircularProgress, Container, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DashboardRoute } from '../router/routes';
import { useSessionAction } from '../providers';
import {
  clearLoginStorageData,
  getLoginStorageData,
  hasValidLoginStorageData,
} from '../api/loginApiHelper';

export interface LoginRedirectProps {}

const LoginRedirect: React.FC<LoginRedirectProps> = () => {
  const navigate = useNavigate();
  const { logInUser } = useSessionAction();

  useEffect(() => {
    const initializeSession = async () => {
      const loginStorageData = getLoginStorageData();
      if (loginStorageData && hasValidLoginStorageData(loginStorageData)) {
        const managerId = loginStorageData.managerId;
        const trainerId = loginStorageData.trainerId;
        const memberId = loginStorageData.memberId;
        const success = await logInUser(managerId, trainerId, memberId);
        if (success) {
          navigate(DashboardRoute.Dashboard);
          return;
        }
      }
      clearLoginStorageData();
      navigate(DashboardRoute.Home);
    };
    initializeSession();
  }, []);

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
        <Typography color="primary" variant="h6" sx={{ mt: 2 }}>
          Loading dashboard data, please wait...
        </Typography>
      </Box>
    </Container>
  );
};

export default LoginRedirect;
